
export function thumbnailForSize(thumbnailUrl, width, height) {
    return `${thumbnailUrl}/width/${width}/height/${height}/type/2`;
}
